import React, { useEffect, useState, useContext } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import api from "../../../api/axios";

const VALID_CALCULATORS = ["buyer", "seller", "refinance", "seller2net", "propnine", "quick", "open"];

export default function DisclaimerModal({ closeModal, onClose, calc }) {
  const theme = useContext(ThemeContext);
  const maincompanyid = theme?.id || null;

  const [disclaimer, setDisclaimer] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!maincompanyid) {
      setLoading(false);
      setError("Company context not available.");
      return;
    }

    let cancelled = false;
    const calculator = calc && VALID_CALCULATORS.includes(String(calc).toLowerCase())
      ? String(calc).toLowerCase()
      : undefined;

    const fetchDisclaimer = async () => {
      try {
        const params = { maincompanyid };
        if (calculator) params.calculator = calculator;
        const { data } = await api.get("/auth/disclaimer", { params });
        const raw = data?.data ?? data;
        const text = raw?.disclaimer ?? raw ?? "";
        if (!cancelled) setDisclaimer(typeof text === "string" ? text : "");
      } catch (err) {
        if (!cancelled) {
          setError(err?.response?.data?.message || "Failed to load disclaimer.");
          setDisclaimer("");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchDisclaimer();
    return () => { cancelled = true; };
  }, [maincompanyid, calc]);

  return (
    <div className="modelspace pplication-fe">
      {loading && (
        <p className="model-desc-details text-gray-500">Loading...</p>
      )}
      {error && !loading && (
        <p className="model-desc-details text-red-600">{error}</p>
      )}
      {!loading && !error && (
        <div
          className="model-desc-details model-desc-details-content"
          dangerouslySetInnerHTML={{ __html: disclaimer || "<p>No disclaimer set.</p>" }}
        />
      )}
    </div>
  );
}
